import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { Alert, AlertTitle, Grid } from "@mui/material";
import { employeeFilterAction, findAllEmployeeAction, findAllEmployeewithoutpaginationAction, findAllEmployeewithoutPaginationAction } from "../../../actions/employeeManagmentAction";
import { Skeleton, Typography } from "@mui/material";
import ColumnVisible from "../../extraComponents/ColumnVisible";
import { TableData } from "../../Table/Table";
import DownloadPdf from "../../extraComponents/DownloadPdf";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";
import LeadsFilterSearch from "../../Leads/LeadsFilterSearch";
import DownloadExcel from "../../extraComponents/DownloadExcel";
import { successTrueMsgAction } from "../../../actions/globalAction";
import { SUCCESS_TRUE_MSG_ERR } from "../../../constants/roleManagmentConstant";
import axios from "axios";

function EmployeeMain() {
  const dispatch = useDispatch();

  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const [data, setData] = useState([]);
  const [reset, setReset] = useState(false);
  const [filterPassData, setFilterPassData] = useState();
  const [whichFilter, setwhichFilter] = useState();
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [pagiantionEntry, setPagiantionEntry] = useState(25);
  const [viewedColumn, setViewedColumn] = useState([])
  const [columnVisibilityData, setColumnVisibilityData] = useState([])
  const [searchPagination, setSearchPagination] = useState(false)
  const [filterPagination, setFilterPagination] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [searchPaginationCount, setSearchPaginationCount] = useState(0)
  const [currentFilterData, setCurrentFilterData] = useState(null);
  

  let { deleteEmployeeSuccess } = useSelector((state) => {
    return state.deleteEmployee;
  });

  let { employeeStatusUpdateSuccess } = useSelector((state) => {
    return state.updateEmployeeStatus;
  });

  let {
    employeeBulkUploadLoading,
    employeeBulkUploadSuccess,
    employeeBulkUploadError
  } = useSelector((state) => {
    return state.employeeBulkUpload;
  });

  const { successAlertMsgSuccess, successAlertMsgErr } = useSelector(
    (state) => {
      return state.successTrueMsg;
    }
  );

  const { findEmployeeWithoutPaginationSuccess } = useSelector((state) => state.findEmployeeWithoutPagination)

  const { employeeFilterFindSuccess } = useSelector((state) => state.employeeFilterFind)

  useEffect(() => {
    if (!searchPagination && !filterPagination) {
    dispatch(findAllEmployeeAction(pagiantionEntry, paginationPageNumber));
    dispatch(findAllEmployeewithoutpaginationAction())
    }
  }, [
    dispatch,
    deleteEmployeeSuccess,
    employeeStatusUpdateSuccess,
    employeeBulkUploadSuccess,
    pagiantionEntry,
    paginationPageNumber,
    searchPagination,
    filterPagination
  ]);

  // selectors

  let { findEmployeeLoading, findEmployeeSuccess, findEmployeeErr } =
    useSelector((state) => {
      return state.findAllEmployee;
    });

  // Success popUp for Employee bulkUpload

  useEffect(() => {
    if (employeeBulkUploadSuccess && successAlertMsgSuccess) {
      Swal.fire("Uploaded", `Employeee created successfully`, "success");
      dispatch(successTrueMsgAction(false));
    }
    if (employeeBulkUploadError && successAlertMsgErr) {
      Swal.fire("Failed!", "Employee created Failed", "error");
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
    }
  }, [
    employeeBulkUploadSuccess,
    employeeBulkUploadError,
    successAlertMsgSuccess,
    successAlertMsgErr
  ]);

  useEffect(() => {
    if (findEmployeeSuccess) {
      setAllEmployeeData(
        findEmployeeSuccess?.payload?.filter((value) => value?.firstName !== "admin")
      );
    }
  }, [findEmployeeSuccess, deleteEmployeeSuccess, reset]);

  useEffect(() => {
    if (employeeFilterFindSuccess) {
      setFilterPagination(true);
      setPaginationPageNumber(1);
      setAllEmployeeData(employeeFilterFindSuccess?.payload)
    }
  }, [employeeFilterFindSuccess])

  useEffect(() => {
    const columnVisibilityData = columns.filter((col) => {
      if (viewedColumn.includes(col.field)) {
        return col
      }
    })
    setColumnVisibilityData(columnVisibilityData)
  }, [viewedColumn])

  const { privilege, hasPrivilege } = usePrivilegeCheck();

  // Employee column Visibility
  const [showEmployeeNameColumn, setShowEmployeeNameColumn] = useState(false);
  const [showEmailColumn, setShowEmailColumn] = useState(false);
  const [showMobileColumn, setShowMobileColumn] = useState(false);
  const [showRollColumn, setShowRollColumn] = useState(false);
  const [showStatusColumn, setShowStatusColumn] = useState(false);

  const [columnName, setColumnName] = useState("");

  const toggleNameColumn = (status, columnName) => {
    setViewedColumn((prevColumns) => {
      if (status) {
        return prevColumns.includes(columnName) ? prevColumns : [...prevColumns, columnName];
      } else {
        return prevColumns.filter((col) => col !== columnName);
      }
    });
  };

  useEffect(() => {
    let array = allEmployeeData;
    // ?.reverse();
    setData(
      array?.map((employee, index) => ({
        sl: index + 1,
        employeeId: employee.employeeId,
        id: employee.id,
        name: employee.firstName,
        description: employee.email,
        updatedby: employee?.mobile && employee?.mobile_countryCode
          ? employee?.mobile_countryCode + " " + employee.mobile
          : employee.mobile,
        lastupdateby: employee?.role?.roleName,
        branch: employee?.user_Branches
          ? employee?.user_Branches.map(
            (value) => value?.branch_master?.branchName
          )
          : null,
        status: employee.status,
        roleId: employee.fk_role_id
      }))
    );
  }, [allEmployeeData]);

  const columns = [
    {
      title: "Sl no",
      field: "slno",
      // type: "numeric",
      // hidden: true,
      headerStyle: { backgroundColor: "#F9F9FB" }
    },
    {
      title: "Employee ID",
      field: "employeeId",
      // hidden: showEmployeeNameColumn,
      headerStyle: { backgroundColor: "#F9F9FB" }
    },
    {
      title: "Employee Name",
      field: "roleName",
      // hidden: showEmployeeNameColumn,
      headerStyle: { backgroundColor: "#F9F9FB" }
    },
    {
      title: "Mail ID",
      field: "description",
      // hidden: showEmailColumn,
      headerStyle: { backgroundColor: "#F9F9FB" }
    },
    {
      title: "Mobile",
      field: "updateby",
      // hidden: showMobileColumn,
      headerStyle: { backgroundColor: "#F9F9FB" }
    },
    {
      title: "Role",
      field: "lastupdateby",
      // hidden: showRollColumn,
      headerStyle: { backgroundColor: "#F9F9FB" }
    },

    {
      title: "Branch",
      field: "Branch",
      // hidden: showRollColumn,
      headerStyle: { backgroundColor: "#F9F9FB" }
    },
    {
      title: "Status",
      field: "status",
      // hidden: showStatusColumn,
      headerStyle: { backgroundColor: "#F9F9FB" }
    },
    {
      title: "Action",
      field: "action",
      filtering: false,
      headerStyle: { backgroundColor: "#F9F9FB" }
    }
  ];

  const LeadFilterFunction = (filterData) => {
    setCurrentFilterData(filterData);
    setSearchPagination(false);
    setFilterPagination(true);
    setPaginationPageNumber(1);
    dispatch(employeeFilterAction(filterData, pagiantionEntry, 1))
  };

  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
    setPaginationPageNumber(1);
    setSearchPagination(false);
    setFilterPagination(false);
    setSearchValue('');
    setCurrentFilterData(null);
    dispatch(findAllEmployeeAction(pagiantionEntry, 1));
  };

  const searchHandleChange = async (e) => {
    try {
      const value = encodeURIComponent(e.target.value.trim())

      if (value === "") {
        setSearchPagination(false);
        dispatch(findAllEmployeeAction(pagiantionEntry, paginationPageNumber));
      }

      setSearchValue(value);
      setSearchPagination(true);
      setFilterPagination(false);

      fetchSearchResults(value, paginationPageNumber)

    } catch (error) {
      console.error(error);
    }
  }

  const fetchSearchResults = async (value, pageNum) => {    
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;

      const { data } = await axios.get(`/api/admin/role/searchemployee?q=${value}&
          &pagenumber=${paginationPageNumber}&limit=${pagiantionEntry}&id=${UserId}`, config)          

      setSearchPaginationCount(data?.totalCount);

      setData(
        data?.payload?.map((employee, index) => ({
          sl: index + 1,
          employeeId: employee.employeeId,
          id: employee.id,
          name: employee.firstName,
          description: employee.email,
          updatedby: employee.mobile,
          lastupdateby: employee?.role?.roleName,
          branch: employee?.user_Branches
            ? employee?.user_Branches.map(
              (value) => value?.branch_master?.branchName
            )
            : null,
          status: employee.status
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const excelDownloadClick = () => {
    DownloadExcel(columns, data, "All_Employee_Managment");
  };

  const pdfDownloadClick = () => {
    DownloadPdf(columns, data, "Employee_Managment", "Employee Managment");
  };

  const paginationDataFetching = (pageNumber) => {
    try {
      setPaginationPageNumber(pageNumber);

      if (searchPagination && searchValue) {
        fetchSearchResults(searchValue, pageNumber);
      } else if (filterPagination && currentFilterData) {
        dispatch(employeeFilterAction(currentFilterData, pagiantionEntry, pageNumber));
      } else {
        dispatch(findAllEmployeeAction(pagiantionEntry, pageNumber));
      }
    } catch (error) {
      console.error(error);
    }
  };  

  const handlePaginationEntry = (e) => {
    let value = e.target.value;
    setPagiantionEntry(value);

    setPaginationPageNumber(1);

    if (searchPagination && searchValue) {
      fetchSearchResults(searchValue, 1);
    } else if (filterPagination && currentFilterData) {
      dispatch(employeeFilterAction(currentFilterData, value, 1));
    } else {
      dispatch(findAllEmployeeAction(value, 1));
    }
  }

  if (!hasPrivilege("employee managment") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  return (
    <>
      <ColumnVisible
        columnVisibleHandler={toggleNameColumn}
        pdfDownloadClick={pdfDownloadClick}
        component="employee"
        employeeRow1={showEmployeeNameColumn}
        employeeRow2={showEmailColumn}
        employeeRow3={showMobileColumn}
        employeeRow4={showRollColumn}
        columnName={columnName}
        filterPassData={filterPassData ? filterPassData : null}
        whichFilter={whichFilter ? whichFilter : null}
        handleResetData={handleResetData}
        searchHandleChange={searchHandleChange}
        excelDownloadClick={excelDownloadClick}
        subMenu="employee managment"
        column={columns}
        viewedColumn={viewedColumn}
      />
      <Grid container spacing={1}>

        <Grid item xs={2.5} sx={{ mt: "-20px" }}>
          <LeadsFilterSearch
            statusComponent="employee"
            LeadFilterFunction={LeadFilterFunction}
            handleResetData={handleResetData}
            data={findEmployeeWithoutPaginationSuccess?.payload}
            pagiantionEntry={pagiantionEntry}
            handlePaginationEntry={handlePaginationEntry}
          />
        </Grid>
        <Grid item xs={9.5}>

        {findEmployeeLoading || employeeBulkUploadLoading ? (
          //  <Skeleton variant="rect" width="100%" height={500} />

          <>
            {/* <Skeleton /> */}
            <Typography variant="h1">
              <Skeleton animation={false} />
            </Typography>
            <Typography variant="h3">
              <Skeleton animation="wave" />
            </Typography>
            <Skeleton animation={false} />
            <Typography variant="h3">
              <Skeleton animation="wave" />
            </Typography>
            <Skeleton animation={false} />
            <Typography variant="h3">
              <Skeleton animation="wave" />
            </Typography>
            <Skeleton animation={false} />
            <Typography variant="h3">
              <Skeleton animation="wave" />
            </Typography>
            <Skeleton animation={false} />
          </>
        ) : (
          <>
              <TableData
                data={data}
                columns={columnVisibilityData.length > 0 ? columnVisibilityData : columns}
                allRoleFindSuccess={findEmployeeSuccess?.payload}
                showRollNameColumn={showEmployeeNameColumn}
                showDescriptionNameColumn={showEmailColumn}
                showUpdatebyNameColumn={showMobileColumn}
                showLastUpdatebyNameColumn={showRollColumn}
                showStatusColumn={showStatusColumn}
                component="employee"
                showUrl="/Administration/employee/details"
                pagiantionEntry={pagiantionEntry}
                paginationPageNumber={paginationPageNumber}
                subMenu="employee managment"
                paginationDataFetching={paginationDataFetching}
                // totalCount={findEmployeeSuccess?.totalCount}
                totalCount={
                  searchPagination ? searchPaginationCount : 
                  filterPagination ? employeeFilterFindSuccess?.totalCount :
                  findEmployeeSuccess?.totalCount
                }
                viewedColumn={viewedColumn}
              // requestSort={requestSort}
              // sortOrder={sortOrder}
              // sortBy={sortBy}
              />
          </>
        )}
            </Grid>
      </Grid>
    </>
  );
}

export default EmployeeMain;
